import { cn } from "@/lib/utils.ts";

export function SelectorBackground({ className }: { className?: string }) {
  return (
    <div
      className={cn("max-w-full overflow-clip flex justify-center", className)}
    >
      <svg
        className="m-auto flex-shrink-0"
        width="2498"
        height="198"
        viewBox="0 0 2498 198"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.99013 250.228C1.66013 249.684 -0.0178567 248.984 0.000143286 248.148C0.141143 241.748 97.8642 226.937 290.453 204.13C304.934 202.415 319.885 200.34 334.89 197.963C349.222 195.692 364.09 193.069 379.078 190.163C406.811 184.79 435.615 178.363 467.135 170.521C525.841 155.911 583.713 138.948 644.982 120.99C734.511 94.748 827.088 67.613 926.355 47.054C952.009 41.741 977.503 37.006 1002.13 32.981C1028.54 28.664 1055 24.992 1080.78 22.067C1108.11 18.967 1135.66 16.589 1162.66 15.007C1191.05 13.344 1219.81 12.5 1248.12 12.5C1274.41 12.5 1300.91 13.237 1326.86 14.689C1351.62 16.074 1376.73 18.158 1401.47 20.883C1424.88 23.46 1448.81 26.704 1472.58 30.523C1494.82 34.096 1517.78 38.31 1540.83 43.05C1562.31 47.468 1583.9 52.326 1606.84 57.904C1627.29 62.877 1648.36 68.314 1671.25 74.526C1713.78 86.067 1756.48 98.65 1797.77 110.819L1797.83 110.836C1860.28 129.243 1924.86 148.276 1991.93 164.669C2028.08 173.5 2061.92 180.851 2095.41 187.144C2113.57 190.557 2131.84 193.685 2149.69 196.444C2168.44 199.339 2187.39 201.925 2206.03 204.132C2398.43 226.916 2496.06 241.72 2496.2 248.132C2496.22 248.968 2494.55 249.669 2491.23 250.215C2480.83 246.7 2453.79 241.725 2410.85 235.427C2362.88 228.393 2293.97 219.546 2206.03 209.127C2187.4 206.921 2168.45 204.335 2149.69 201.439C2131.83 198.682 2113.57 195.554 2095.41 192.139C2061.92 185.852 2028.07 178.5 1991.94 169.668C1924.86 153.276 1860.29 134.244 1797.84 115.839H1797.82C1756.52 103.666 1713.81 91.077 1671.25 79.529C1648.35 73.315 1627.28 67.878 1606.84 62.907C1583.9 57.329 1562.3 52.47 1540.83 48.054C1517.77 43.313 1494.81 39.099 1472.58 35.527C1448.81 31.708 1424.88 28.465 1401.47 25.887C1376.73 23.162 1351.62 21.078 1326.86 19.693C1300.91 18.237 1274.42 17.5 1248.12 17.5C1219.8 17.5 1191.05 18.344 1162.65 20.008C1135.65 21.59 1108.1 23.966 1080.77 27.068C1055 29.993 1028.54 33.668 1002.12 37.982C977.499 42.006 952.006 46.741 926.349 52.055C827.081 72.615 734.504 99.749 644.975 125.991L644.949 125.999C583.689 143.954 525.827 160.914 467.13 175.522C435.61 183.366 406.807 189.791 379.074 195.165C364.074 198.071 349.208 200.694 334.887 202.965C319.874 205.344 304.923 207.419 290.45 209.132C202.434 219.555 133.465 228.407 85.4601 235.443C42.4821 241.741 15.4071 246.716 4.99013 250.228Z"
          fill="url(#paint0_linear_285_124)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_285_124"
            x1="287.063"
            y1="244.047"
            x2="1993.74"
            y2="849.941"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1A1023" />
            <stop offset="0.15" stopColor="#000000" />
            <stop offset="0.167" stopColor="#775CDF" />
            <stop offset="0.365" stopColor="#8570D4" />
            <stop offset="0.414" stopColor="#DFFE00" />
            <stop offset="0.695" stopColor="#DFFE00" />
            <stop offset="0.85" stopColor="#000000" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
